'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('@emotion/styled');
var coreRenderer = require('@tempi/core-renderer');
var constants = require('../constants.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Content = styled__default["default"].div(
  ({ grid, commonStyle }) => {
    const {
      gridArea,
      navigationGridTemplateColumns,
      width,
      mobileNavigationGridTemplateColumns
    } = grid;
    return `
    position: relative;
    display: grid;
    grid-area: ${gridArea};
    grid-template-columns: ${navigationGridTemplateColumns};
    align-items: center;
    width: 100%;
    max-width: ${width || 1240}px;
    margin: 0 auto;
    
    ${coreRenderer.getStyle({ padding: commonStyle.padding })};
  
    @media screen and (max-width: ${constants.MOBILE_WIDTH}px){
      grid-template-columns: ${mobileNavigationGridTemplateColumns};
    }
  `;
  }
);

exports.Content = Content;
